// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"Breadcrumb_breadcrumb__3GJMO","breadcrumbLink":"Breadcrumb_breadcrumbLink__Cjsvb","currentLink":"Breadcrumb_currentLink__2wiOX","divider":"Breadcrumb_divider__PbPc2"};